import styled from 'styled-components';

export default styled.div`
  margin: 0 10px 0;
  width: 100%;

  .partido {
    height: 100%;
    float: left;
  }
  .porcentaje-pactometro {
    position: relative;
    height: ${props => `${props.height}px`};
  }
  .bloque-pactometro {
    position: relative;
    width: 100%;
    .bloque-pactometro-barra {
      background: #e8e7e7;
    }
    &:last-of-type {
      margin-bottom: 5px;
    }
    &::before {
      content: '';
      height: 8px;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
      z-index: 2;
    }
    @media screen and (min-width: 640px) {
      flex: 1;
    }
    .lasexta & {
      &:nth-child(2) {
        display: none;
      }
    }
  }
  .bloque-gris-votos {
    background: #e8e7e7;
    margin-bottom: 20px;
    position: relative;
    width: 100%;
    &::before {
      content: '';
      height: 8px;
      left: 0;
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
      z-index: 2;
    }
  }
  .total-pactometro {
    background-color: white;
    font-size: 12px;
    text-align: left;
    margin: 0;
    padding-bottom: 5px;
    width: 100%;
    .total-pactometro-value {
      color: #007201;
    }
  }
  .mayoria-pactometro-barras {
    left: 50%;
    height: 100%;
    position: absolute;
    text-align: center;
    z-index: 3;
    transform: translate(-50%, 0%);
    p {
      font-size: 12px;
      margin: 0;
      position: relative;
      top: -20px;
    }
    &.down {
      p {
        top: ${props => `${props.height + 5}px`};
      }
    }

    &::before {
      content: '';
      border-left: 1px solid #000;
      display: block;
      left: 50%;
      height: ${props => `${props.height + 10}px`};
      position: absolute;
      width: 1px;
      z-index: 3;
      top: -5px;
    }
    &.solid::before {
      border-left-style: solid;
    }
  }
  @media (min-width: 768px) {
    .porcentaje-pactometro {
      height: 45px;
    }
    .mayoria-pactometro-barras {
      &::before {
        height: 56px;
      }
      &.down {
        p {
          top: 58px;
        }
      }
    }
  }
`;
